<template>
  <div class="view-member-area-comments">
    <b-tabs class="my-6" content-class="mt-6" lazy>
      <b-tab title="Em revisão" active>
        <comments-list status="review" />
      </b-tab>
      <b-tab title="Aprovados">
        <comments-list status="published" />
      </b-tab>
      <b-tab title="Oculto">
        <comments-list status="blocked" />
      </b-tab>
      <b-tab>
        <template #title>
          <div class="d-flex">
            <span class="mr-3">Perfil Moderador</span>
            <bp-tooltip
              text="Personalize a visualização de quem está respondendo os comentários."
            >
              <i class="fa fa-circle-info fs-12" />
            </bp-tooltip>
          </div>
        </template>

        <comments-profile />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import BpTooltip from "@/components/designSystem/BpTooltip.vue";
import CommentsList from "@/components/product/member-area/comments/CommentsList";
import CommentsProfile from "@/components/product/member-area/comments/CommentsProfile.vue";
import ProductActionsMixin from "@/mixins/productActions.js";
import { getToken } from "@/setup/api";
import { mapState } from "vuex";

export default {
  mixins: [ProductActionsMixin],
  components: { CommentsList, BpTooltip, CommentsProfile },
  computed: {
    ...mapState("product", ["product"]),
    ...mapState("membersSetup", ["setup"]),
    breadcrumbs() {
      return [
        { title: "Meus produtos", link: "product" },
        {
          title: this.product?.name || "...",
          link: "product-details",
          params: { id: this.product?.id }
        },
        { title: "Comentários" }
      ];
    },
    membersURL() {
      return `https://${
        this.setup?.subdomain
      }.club.blitzpay.com.br/token?token=${getToken()}`;
    }
  },
  mounted() {
    this.$store.dispatch("membersSetup/get", this.$route.params.id);
    this.$store.dispatch("membersModules/get", {
      product_id: this.$route.params.id
    });
  }
};
</script>
<style lang="scss" scoped>
.view-member-area-comments {
  ::v-deep {
    .nav-item {
      .nav-link {
        padding: 12px;
      }
      @media screen and (max-width: 991px) {
        flex: 1;
        text-align: center;
      }
    }
  }
}
</style>
